/* v8 ignore file -- @preserve */
import { ref } from 'vue';
import useProvideFactory from '../dumb/useProvideFactory';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

export const REGISTRY_SLIDE_OUT_REPOSITORY = Symbol('REGISTRY_SLIDEOUT_REPOSITORY');

export function getRegistrySlideOutSharedState() {
  return ref('');
}

export function useRegistrySlideOutProvide(useAsInject) {
  return useProvideFactory({
    key: REGISTRY_SLIDE_OUT_REPOSITORY,
    factory: getRegistrySlideOutSharedState,
    useAsInject,
  });
}

export default function useRegistrySlideout() {
  const slideoutId = useRegistrySlideOutProvide(true);

  function init(id) {
    slideoutId.value = id;
  }

  function toggleSlideout() {
    const slideoutStore = useSlideoutStore();
    slideoutStore.toggle(slideoutId.value);
  }

  function openRegistrySlideout() {
    toggleSlideout();
  }

  return {
    slideoutId,
    init,
    openRegistrySlideout,
    toggleSlideout,
  };
}
